import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { customerActions } from "@_actions/customer.actions.js";
import { Button, Menu, MenuItem } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function LangSelector() {
  const customerDetails = useSelector((state) => state.customerReducer);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const toLangCode = (lang) => {
    if (!lang) return null;
    if (lang.indexOf("-") >= 0) {
      return lang.split("-")[0];
    }
    return lang;
  };

  const langCode =
    toLangCode(customerDetails.customer.translation) ||
    toLangCode(sessionStorage.getItem("i18nextLng"));

  const allLanguageCodes = customerDetails.customer.available_translations;
  const allLanguages = {};

  for (let el of allLanguageCodes) {
    allLanguages[el.language] = el.name;
  }

  const changeLanguage = (langCode) => {
    dispatch(customerActions.customer(window.location.hostname, langCode));
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const generateLangItems = () => {
    var list = [];
    for (const langCode in allLanguages) {
      list.push(
        <MenuItem
          sx={{ fontSize: 16 }}
          onClick={() => changeLanguage(langCode)}
          key={langCode}
        >
          {allLanguages[langCode]}
        </MenuItem>,
      );
    }
    return list;
  };

  return (
    <>
      <Button
        sx={{
          width: 175,
          color: "#3A7BD3",
          textTransform: "none",
          fontSize: 16,
          px: 1.25,
          py: 1.25,
        }}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        endIcon={<ExpandMoreIcon />}
      >
        {allLanguages[langCode]}
      </Button>
      <Menu
        slotProps={{
          paper: {
            sx: {
              width: 175,
              border: "1px solid #CCCCCC",
              boxShadow: "none",
              borderRadius: 0,
              p: 0.375,
            },
          },
        }}
        id="menu-appbar"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        {generateLangItems()}
      </Menu>
    </>
  );
}

export default LangSelector;
